/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignInRequest } from '../../models/sign-in-request';
import { SignInResponse } from '../../models/sign-in-response';

export interface AuthSignIn$Json$Params {
      body: SignInRequest
}

export function authSignIn$Json(http: HttpClient, rootUrl: string, params: AuthSignIn$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponse>> {
  const rb = new RequestBuilder(rootUrl, authSignIn$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInResponse>;
    })
  );
}

authSignIn$Json.PATH = '/api/v1/auth/sign-in';
